var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "DefaultContentLayout",
    {
      scopedSlots: _vm._u([
        {
          key: "right-side",
          fn: function () {
            return [
              _c("DocumentsContractorProjectFilters", {
                attrs: { filters: _vm.filters },
                on: {
                  filtersChanged: _vm.updateFilters,
                  resetFilters: _vm.resetFilters,
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.isEmptyListPlaceholderShown
        ? _c("EmptyListPlaceholder", {
            attrs: { title: "No documents available" },
            scopedSlots: _vm._u(
              [
                {
                  key: "image",
                  fn: function () {
                    return [_c("EmptyListImageDocuments")]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2273432899
            ),
          })
        : _c(
            "div",
            [
              _c(
                "LoadingOverlay",
                {
                  attrs: {
                    hasData: !_vm.isCollectionEmpty,
                    loading: _vm.isLoading,
                  },
                },
                [
                  _vm.isCollectionEmpty
                    ? _c("EmptyListPlaceholder", {
                        attrs: { title: "No documents found for your request" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "image",
                              fn: function () {
                                return [_c("EmptyListImageDocuments")]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2273432899
                        ),
                      })
                    : _c(
                        "div",
                        [
                          _c("ActionsPanel", {
                            staticClass: "mb-3",
                            attrs: { total: _vm.paginationConfig.total },
                          }),
                          _vm._l(_vm.documents, function (document) {
                            return _c(
                              "DocumentItem",
                              {
                                key: document.id,
                                attrs: {
                                  document: document,
                                  currentUser: _vm.currentUser,
                                  frozen: "",
                                },
                              },
                              [
                                _c("CardBodyLink", {
                                  attrs: {
                                    label: "Client",
                                    routeParams: {
                                      id: _vm.getProject(document).id,
                                    },
                                    routeName:
                                      _vm.RouteNames
                                        .CONTRACTOR_PROJECT_ACTIVITY,
                                    value: _vm.getProject(document)?.name,
                                  },
                                }),
                                _c("CardBodyLink", {
                                  attrs: {
                                    label: "Company",
                                    routeParams: { id: document?.company?.id },
                                    routeName: _vm.RouteNames.NETWORK_COMPANY,
                                    value: document?.company?.business_name,
                                  },
                                }),
                              ],
                              1
                            )
                          }),
                          _c("CardPagination", {
                            attrs: { config: _vm.paginationConfig },
                            on: {
                              "update:config": function ($event) {
                                _vm.paginationConfig = $event
                              },
                            },
                          }),
                        ],
                        2
                      ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }